const tr = {
  nav: {
    work: 'İşler',
    clients: 'Müşteriler',
    about: 'Hakkımda',
    writing: 'Yazılar',
    contact: 'İletişim',
    photos: 'Fotoğraflar',
    home: 'Ana Sayfa',
    menu: 'Menü',
    open: 'Uzaktan işlere açığım',
    themeLabel: 'Temayı değiştir',
  },
  hero: {
    eyebrow: 'Backend odaklı full stack geliştirici',
    h1: 'Merhaba, ben Furkan.',
    h1b: 'Fikirden ürüne, ve ötesine.',
    p: 'Kodlamadan önce düşünürüm, müşteriyle birlikte planlarım, AI agent’larla ama kendi kontrolümde geliştiririm; test eder, yayına alır ve yayından sonra da geliştirmeye devam ederim.',
    seeWork: 'İşlerime bak ↓',
    resume: 'Özgeçmiş ↗',
    stageLabel: 'Fikirden ürüne, ve ötesine',
  },
  proof: {
    eyebrow: '(01) Kanıt',
    heading: 'İddia değil, ölçüm.',
    p1l: '01 · doğruluk',
    p1d: 'geçerli soru asistana iletildi, hiçbiri yanlışlıkla engellenmedi',
    p2l: '02 · hız',
    p2d: 'daha hızlı ön kontrol (~0,4 sn), tam model cevabına (~60 sn) kıyasla',
    p3l: '03 · destek',
    p3d: 'kurucu ortak olarak kazanılan TÜBİTAK araştırma desteği',
    p4l: '04 · yayında',
    p4u: ' canlı',
    p4d: 'müşteri sitesi yayında, her birinde özel admin paneli',
  },
  work: {
    eyebrow: '(02) Seçili işler',
    heading: 'Yüzeyde ürün.',
    heading2: 'Altında sistem.',
    clientEyebrow: '(03) Müşteri işleri',
    clientHeading: 'Canlıda.',
    clientHeading2: 'Uçtan uca geliştirildi ve işletiliyor.',
    role: 'Rol',
    caseStudy: 'Vaka çalışması →',
    live: 'Canlı ↗',
    product: 'Ürün',
    hood: 'Nasıl çalışır',
    replay: '↻ Tekrar oynat',
    stackLbl: 'stack',
    project: 'Proje',
    loading: 'Projeler yükleniyor...',
    error: 'Projeler yüklenemedi.',
  },
  studies: {
    eyebrow: '(04) Arayüz çalışmaları',
    heading: 'Hareket ve detay,',
    heading2: 'pratik için.',
  },
  about: {
    eyebrow: '(05) Hakkımda',
    sub: 'Bilgisayar Mühendisliği, Pamukkale Üniversitesi',
    p1: 'Network tarafında başladım; switch ve firewall yapılandırdım, sonra yazılıma geçtim.',
    p2: 'Bu yol nasıl geliştirdiğimi belirliyor: istek nereye gidiyor, yolda ne bozulabilir ve çalıştığını nasıl kanıtlarım?',
    skills: [
      ['Backend', 'Go, Python, Django REST, PostgreSQL, Redis'],
      ['Frontend', 'TypeScript, React, Next.js, Vue'],
      ['Altyapı & ağ', 'Linux, Docker, Nginx, CI/CD, Cisco & Huawei, FortiGate, F5 WAF'],
    ],
    experience: 'Deneyim',
    jobs: [
      ['2026', 'Teknoloji Stajyeri', 'ATİLAB · İstanbul'],
      ['2026 — halen', 'Kurucu Ortak & Full Stack Geliştirici', 'KeyStrada · PropTech'],
      ['2025', 'BT Network Stajyeri', 'TOFAŞ · Bursa'],
      ['2024 — halen', 'Full Stack Geliştirici · Freelance', 'Uzaktan'],
      ['2024', 'Erasmus+ Öğrencisi', 'Međimurje Üniversitesi · Hırvatistan'],
      ['2022 — 2026', 'Bilgisayar Mühendisliği Lisans', 'Pamukkale Üniversitesi'],
    ],
  },
  writing: {
    eyebrow: '(06) Yazılar',
    allPosts: 'Tüm yazılar →',
  },
  contact: {
    eyebrow: '(07) İletişim',
    heading: 'Ayakta kalan bir sistem mi lazım?',
    heading2: 'Konuşalım.',
  },
  footer: {
    built: 'Bursa’da geliştirildi',
  },
  photos: {
    eyebrow: 'Fotoğraflar',
    heading: 'Son Gezdiğim Yerler',
    loading: 'Fotoğraflar yükleniyor...',
    error: 'Fotoğraflar yüklenemedi.',
    photosLabel: 'fotoğraf',
    noPhotosFound: 'Fotoğraf bulunamadı.',
  },
  blog: {
    eyebrow: 'Yazılar',
    heading: 'Blog',
    subheading: 'Yazılım geliştirme ve daha fazlası üzerine kişisel yazılarım.',
    postsLabel: 'yazı',
    backToBlog: "Blog'a Dön",
    noPostsFound: 'Yazı bulunamadı.',
    loading: 'Yükleniyor...',
    error: 'Yazılar yüklenemedi.',
    allCategories: 'Tümü',
    pageOf: 'Sayfa {page} / {total}',
    previous: 'Önceki',
    next: 'Sonraki',
  },
};

export default tr;
